import { useState, useContext, useEffect } from 'react'
import authContext from '../authContext'
import axios from 'axios'

const useGet = (url, atualizar) => {
  const [data, setData]       = useState({})
  const [loading, setLoading] = useState(true)
  const { token }             = useContext(authContext)

  const load = async () => {
    setLoading(true)
    const client = axios.create({
      headers: {
        authentication: token
      }
    })

    const data = await client.get(url)
    if (data.data.lista) {
      setData(data.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (token !== '') {
      load()
    }
  }, [token])

  useEffect(() => {
    // console.log('atualizar', atualizar)
    let timer = null
    if (atualizar && atualizar > 0) {
      timer = setInterval(() => {
        if (!loading) {
          load()
        }
      }, atualizar)
    }

    return () => {
      // limpar interval
      //console.log('limpar interval')
      if (timer) {
        clearInterval(timer)
      }
    }
  }, [atualizar, loading])

  return [data, loading]
}

export default useGet
